import styled from 'styled-components';
import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    eventsViewOuterContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    eventsViewInnerContainer: {
      background: 'white',
      minWidth: '100%',
      borderRadius: '8px',
      height: '809px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      padding: '32px 64px 40px 64px',
      [theme.breakpoints.down('lg')]: {
        height: '1640px'
      }
    },
    eventsHeaderBlock: {
      background: 'transparent',
      minWidth: '100%',
      flex: '0 1 auto',
      height: 'auto',
      minHeight: '101px',
      maxHeight: '172px',
      [theme.breakpoints.down('lg')]: {
        minHeight: '280px',
        maxHeight: '310px'
      }
    },
    eventsSearchInput: {
      justifyContent: 'space-around',
      alignItems: 'center',
      paddingBottom: '23px',
      [theme.breakpoints.down('lg')]: {
        paddingTop: '0px',
        paddingBottom: '0px'
      }
    },
    eventsSearchInputBox: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
      [theme.breakpoints.down('lg')]: {
        columnGap: '9px',
        paddingBottom: '25px'
      }
    },
    eventsCardContainer: {
      display: 'flex',
      justifyContent: 'center',
      height: '461px',
      background: 'transparent',
      flexDirection: 'row',
      marginBottom: '40px',
      minWidth: '100%',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        height: 'fit-content',
        marginBottom: '23px'
      }
    },
    eventsCardBox: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 16px 0px 16px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
        margin: '20px 0',
        padding: '0px'
      }
    },
    eventsCardContent: {
      flexDirection: 'column',
      width: '365px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'row',
        width: '755px',
        height: '250px'
      }
    },
    eventsCardImage: {
      justifyContent: 'center',
      alignItems: 'center',
      height: '275px',
      background: 'transparent',
      overflow: 'hidden',
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        width: '333px',
        height: '100%',
        alignItems: 'normal'
      }
    },
    eventsDefaultImage: {
      height: '100%',
      objectFit: 'cover',
      [theme.breakpoints.down('lg')]: {
        width: 'auto'
      }
    },
    eventsViewImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: '8px 8px 0px 0px',
      [theme.breakpoints.down('lg')]: {
        borderRadius: '8px 0px 0px 8px'
      }
    },
    eventsHorizontalDivider: {
      marginTop: '-1px',
      padding: '0px 24px',
      background: 'transparent',
      maxHeight: '5px',
      display: 'block',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    eventsVerticalDivider: {
      display: 'none',
      background: 'rgba(155,155,155)',
      height: '248px',
      width: '1px',
      [theme.breakpoints.down('lg')]: {
        display: 'block'
      }
    },
    eventsCardText: {
      display: 'flex',
      justifyContent: 'space-between',
      height: '185px',
      background: 'transparent',
      padding: '12px 24px',
      alignItems: 'stretch',
      flexWrap: 'nowrap',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        justifyContent: 'space-around',
        width: '420px',
        height: '100%'
      }
    },
    eventsNameButtonBox: {
      display: 'inline-flex',
      flexDirection: 'column'
    },
    eventsDateButtonBox: {
      display: 'inline-flex',
      flexDirection: 'column'
    },
    eventsSearchNotFound: {
      width: '100%',
      background: 'transparent',
      [theme.breakpoints.down('lg')]: {
        height: '1200px'
      }
    },
    eventsSearchButton: {
      [theme.breakpoints.down('lg')]: {
        minWidth: '300px',
        maxWidth: 'fit-content',
        fontSize: '30px'
      }
    },
    eventsNoEventsBlock: {
      height: '415px',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        height: 'max-content',
        padding: '0px 0px 114px 0px'
      }
    },
    eventsNoEventsImage: {
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      padding: '64px 0px 24px 0px',
      [theme.breakpoints.down('lg')]: {
        padding: '0px 0px 49px 0px'
      }
    },
    eventsHeaderText: {
      [theme.breakpoints.down('lg')]: {
        width: '100% !important',
        minHeight: '100px',
        maxHeight: '240px'
      }
    }
  })
);

/**
 * Hidden button to access seat selection demo
 */
export const HiddenButton = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  flex: none;
  height: 100px;
  width: 100px;
  background: transparent;
  z-index: 2147483647;
`;
